export default "__VITE_ASSET__DFlxVS4G__"